import { MarketingRepo } from '@core/repositories'
const resource = "/orders";

export default {
  fetch(payload, config) {
    return MarketingRepo.get(`${resource}.json`, payload, config);
  },
  show(orderId, config) {
    return MarketingRepo.get(`${resource}/${orderId}.json`, config);
  }
}